import { Userdata } from "@/types/user";
import { AUTHENTICATION_TAGS } from "@/api/authentication.constraints";
import { baseApi } from "@/api/baseApi";

export interface CurrentUserPatchPayload {
  name?: string;
  surname?: string;
  phoneNumber?: string;
  dateFormat?: string;
  timeFormat?: string;
  /** Empty string clears the override (backend falls back to `<display name> (Pathfinder)`). */
  aiAuthorName?: string;
}

export const toCurrentUserPatchData = (payload: CurrentUserPatchPayload) => ({
  name: payload.name,
  surname: payload.surname,
  phone_number: payload.phoneNumber || undefined,
  date_format: payload.dateFormat,
  time_format: payload.timeFormat,
  // The backend drops `null` (exclude_none) and clears the column on "", so send the trimmed string.
  ...(payload.aiAuthorName !== undefined ? { ai_author_name: payload.aiAuthorName.trim() } : {}),
});

export const authenticationApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getAuthenticatedUser: builder.query<Userdata, void>({
      providesTags: [AUTHENTICATION_TAGS.AUTHENTICATION_TAG],
      query: () => ({
        url: "/pf-auth/users/current",
      }),
    }),
    updateUser: builder.mutation<void, CurrentUserPatchPayload>({
      invalidatesTags: [AUTHENTICATION_TAGS.AUTHENTICATION_TAG],
      query: data => ({
        url: "/pf-auth/users/current",
        method: "PATCH",
        data: toCurrentUserPatchData(data),
      }),
    }),
  }),
});

export const { useGetAuthenticatedUserQuery, useUpdateUserMutation } = authenticationApi;
